import { render, staticRenderFns } from "./UserSettingsStatistics.vue?vue&type=template&id=3651a599&scoped=true"
import script from "./UserSettingsStatistics.vue?vue&type=script&lang=js"
export * from "./UserSettingsStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3651a599",
  null
  
)

export default component.exports